import PropTypes from 'prop-types';

export default PropTypes.shape({
  display: PropTypes.oneOf(['gear.armor']).isRequired,
  head: PropTypes.shape({
    display: PropTypes.oneOf(['gear.armor.head']).isRequired,
    Quality: PropTypes.string.isRequired,
    Weight: PropTypes.string.isRequired,
    Trait: PropTypes.string.isRequired,
    Glyph: PropTypes.string.isRequired,
    'Glyph Quality': PropTypes.string.isRequired,
    Set: PropTypes.string.isRequired,
    Style: PropTypes.string.isRequired,
  }),
  shoulder: PropTypes.shape({
    display: PropTypes.oneOf(['gear.armor.shoulder']).isRequired,
    Quality: PropTypes.string.isRequired,
    Weight: PropTypes.string.isRequired,
    Trait: PropTypes.string.isRequired,
    Glyph: PropTypes.string.isRequired,
    'Glyph Quality': PropTypes.string.isRequired,
    Set: PropTypes.string.isRequired,
    Style: PropTypes.string.isRequired,
  }),
  chest: PropTypes.shape({
    display: PropTypes.oneOf(['gear.armor.chest']).isRequired,
    Quality: PropTypes.string.isRequired,
    Weight: PropTypes.string.isRequired,
    Trait: PropTypes.string.isRequired,
    Glyph: PropTypes.string.isRequired,
    'Glyph Quality': PropTypes.string.isRequired,
    Set: PropTypes.string.isRequired,
    Style: PropTypes.string.isRequired,
  }),
  legs: PropTypes.shape({
    display: PropTypes.oneOf(['gear.armor.legs']).isRequired,
    Quality: PropTypes.string.isRequired,
    Weight: PropTypes.string.isRequired,
    Trait: PropTypes.string.isRequired,
    Glyph: PropTypes.string.isRequired,
    'Glyph Quality': PropTypes.string.isRequired,
    Set: PropTypes.string.isRequired,
    Style: PropTypes.string.isRequired,
  }),
  waist: PropTypes.shape({
    display: PropTypes.oneOf(['gear.armor.waist']).isRequired,
    Quality: PropTypes.string.isRequired,
    Weight: PropTypes.string.isRequired,
    Trait: PropTypes.string.isRequired,
    Glyph: PropTypes.string.isRequired,
    'Glyph Quality': PropTypes.string.isRequired,
    Set: PropTypes.string.isRequired,
    Style: PropTypes.string.isRequired,
  }),
  hands: PropTypes.shape({
    display: PropTypes.oneOf(['gear.armor.hands']).isRequired,
    Quality: PropTypes.string.isRequired,
    Weight: PropTypes.string.isRequired,
    Trait: PropTypes.string.isRequired,
    Glyph: PropTypes.string.isRequired,
    'Glyph Quality': PropTypes.string.isRequired,
    Set: PropTypes.string.isRequired,
    Style: PropTypes.string.isRequired,
  }),
  feet: PropTypes.shape({
    display: PropTypes.oneOf(['gear.armor.feet']).isRequired,
    Quality: PropTypes.string.isRequired,
    Weight: PropTypes.string.isRequired,
    Trait: PropTypes.string.isRequired,
    Glyph: PropTypes.string.isRequired,
    'Glyph Quality': PropTypes.string.isRequired,
    Set: PropTypes.string.isRequired,
    Style: PropTypes.string.isRequired,
  }),
});
